export const liveEventsRoutes = [
  {
    path: "/app/dashboard",
    redirect: "/app-live-events",
  },
  {
    path: "/app/live-events",
    name: "liveEvents",
    component: () => import("vue-app/pages/PageLiveEvents/PageLiveEvents.vue"),
    meta: {
      routeName: window._trans._liveEvents.title,
      noPadding: true,
      skipGlobalLoader: true,
    },
  },
];
